<div class="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6">
  <!-- Page header -->
  <div class="mb-6 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
    <div class="flex items-start gap-3">
      <app-back-button
        variant="icon"
        size="md"
        fallbackLink="/home/siv-list"
        tooltip="Back to SIV list"
      ></app-back-button>
      <div>
        <h1 class="text-2xl font-bold text-gray-900">{{ 'Create SIV' | translate }}</h1>
        <p class="mt-1 text-sm text-gray-600">
          {{ 'Generate Site Issue Voucher from SRV request' | translate }}
        </p>
        <p *ngIf="sourceSrvReference" class="mt-2 text-sm font-medium text-blue-700">
          Source SRV: {{ sourceSrvReference }}
        </p>
      </div>
    </div>
    <div class="rounded-lg border border-blue-100 bg-white px-4 py-3 shadow-sm">
      <div class="flex items-center gap-3">
        <div class="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-100">
          <svg class="h-5 w-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
        </div>
        <div>
          <p class="text-xs uppercase tracking-wide text-gray-500">Document Type</p>
          <p class="text-sm font-semibold text-gray-900">Site Issue Voucher</p>
        </div>
      </div>
    </div>
  </div>

<form
  [formGroup]="sivFrom"
  (ngSubmit)="onSubmit()"
  class="b1-form p-6 bg-white rounded-lg shadow-md"
>
  <div class="grid grid-cols-12 gap-6">
    <ng-container *ngFor="let field of commonFields">
      <div class="col-span-6" *ngIf="field.type == 'text'">
        <mat-label>{{ field.key | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-full">
          <input matInput [formControlName]="field.key" [type]="field.type" />
        </mat-form-field>
      </div>
      <div class="col-span-6" *ngIf="field.type == 'number'">
        <mat-label>{{ field.key | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-full">
          <input matInput type="number" [formControlName]="field.key" />
        </mat-form-field>
      </div>
      <div class="col-span-6" *ngIf="field.type == 'select'">
        <mat-label>{{ field.key | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-full">
          <mat-select
            [formControlName]="field.key"
            [compareWith]="compareSelectValues"
            (selectionChange)="field.onChange?.($event.value)"
          >
            <mat-option
              *ngFor="let option of optionsMap[field.optionKey]"
              [value]="option.value != null ? option.value : option"
            >
              {{ option.label || option }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="sivFrom.get(field.key)?.hasError('required')">
            {{ field.label }} is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-span-6" *ngIf="field.type == 'textarea'">
        <mat-label>{{ field.key | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-full">
          <textarea matInput [formControlName]="field.key" rows="1"></textarea>
        </mat-form-field>
      </div>
      <div class="col-span-6" *ngIf="field.type === 'date'">
        <mat-label>{{ field.key | translate }}</mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            [matDatepicker]="picker"
            [formControlName]="field.key"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
    </ng-container>
    <ng-container *ngIf="domainFields[selectedDomain]">
      <ng-container *ngFor="let field of domainFields[selectedDomain]">
        <div class="col-span-6">
          <mat-label>{{ field.key | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput [formControlName]="field.key" [type]="field.type" />
          </mat-form-field>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div class="mt-6 flex gap-4">
    <button mat-raised-button color="primary" type="submit">Submit</button>
    <button mat-button type="button" (click)="onReset()">Reset</button>
  </div>
</form>
</div>

